import { useGetHeroBannerPromotion } from '@/features/shop/services/Campaigns/hooks'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { ShowHeroPromoBanner } from '@/features/shop/components/HeroPromoBanner/ShowHeroPromoBanner'

export const HeroPromoBanner = () => {
  const promotionToShow = useGetHeroBannerPromotion()
  return (
    <GridLayoutContainer>
      <ShowHeroPromoBanner promotionToShow={promotionToShow} />
    </GridLayoutContainer>
  )
}
